<template>
    <section>
        <b-row>
            <b-col>
                <configs-table header="Configuraciones generales" fetchingAPI="configs/getall/notAltan" />
            </b-col>
        </b-row>
    </section>
</template>

<script>
import ConfigsTable from './ConfigsTable.vue'
export default {
    components: {ConfigsTable}
}
</script>
        